export default __webpack_public_path__ + "static/media/924.33956c78.png";